import axios from "axios";
import { apiURL } from "./featured";

export function sendOtp(data) {
  return axios.post(`${apiURL}/v4/user/send_otp`, data);
}

export function verifyOtp(data) {
  return axios.post(`${apiURL}/v4/user/verify_otp`, data);
}

export function updateProfile(data) {
  return axios.put(`${apiURL}/v4/user/profile`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export function subscribeEmail(data) {
  return axios.post(`${apiURL}/v3/user/login/email`, data);
}

export function getUserProfile() {
  return axios.get(`${apiURL}/v4/user/profile`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export function activatePartyPass(sessionId) {
  return axios.put(
    `${apiURL}/v4/user/profile`,
    { zebra_id: sessionId },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );
}

export function toggleBookmark(videoId) {
  return axios.put(
    `${apiURL}/video/${videoId}/bookmark`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );
}

export function togglePlaylistBookmark(playlistId) {
  return axios.put(
    `${apiURL}/playlist/${playlistId}/bookmark`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );
}

export function getBookmarks() {
  return axios.get(`${apiURL}/user/bookmarks`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export function getPlaylistBookmarks() {
  return axios.get(`${apiURL}/user/playlist-bookmarks`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export function toggleDislike(videoId) {
  return axios.put(
    `${apiURL}/video/${videoId}/dislike`,
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    }
  );
}
